// All user-facing translation tables live in this folder, one module per area.
// Each table is keyed by language code (en, es, zh, sc).

// The table entry for `lang`, falling back to English.
export const pick = (table, lang) => table[lang] || table.en;

export * from './nav';
export * from './home';
export * from './reading';
export * from './schedule';
export * from './bible';
export * from './search';
export * from './comments';
export * from './dailyBread';
export * from './login';
export * from './notify';
export * from './notifications';
export * from './rename';
export * from './account';
export * from './annotations';
